const closeButtonLabel = "Zapri";
const slSI = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  slSI as default
};
